module.exports = __webpack_public_path__ + "img/Accountor-20-lowres.480acce8.jpg";